module.exports = "static/assets/7bd83c9ad44bff4a20f0c19726adf8be.svg";